import { ReactNode } from 'react';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Button, { Props as ButtonProps } from 'components/button/Button';

interface ModalFormSubmitButtonProps
  extends Omit<ButtonProps, 'children' | 'type'> {
  children?: ReactNode;
  'data-testid'?: string;
  /**
   * Whether to disable or not the button based on the form's isDirty state.
   * @default true
   */
  disabledIfNotDirty?: boolean;
}

const ModalFormSubmitButton = ({
  bsStyle,
  children,
  'data-testid': dataTestId,
  disabledIfNotDirty = true,
  disabled,
  ...props
}: ModalFormSubmitButtonProps) => {
  const { t } = useTranslation();
  const { isDirty, isSubmitting } = useFormState();

  return (
    <Button
      bsStyle={bsStyle ?? 'primary'}
      data-testid={dataTestId ?? 'modal-form-submit-button'}
      disabled={(disabledIfNotDirty && !isDirty) || (disabled ?? isSubmitting)}
      type="submit"
      {...props}
    >
      {children ?? t(isSubmitting ? 'common.saving' : 'common.save')}
    </Button>
  );
};

ModalFormSubmitButton.defaultProps = {
  children: undefined,
  'data-testid': undefined,
  disabledIfNotDirty: undefined,
};

export default ModalFormSubmitButton;
